import { Check, Circle } from '@digital-twins/design-system/icons'
import { useTranslation } from 'react-i18next'
import { validatePassword } from '@/lib/utils/password-validation'

interface PasswordRulesChecklistProps {
  password: string
}

export function PasswordRulesChecklist({ password }: PasswordRulesChecklistProps) {
  const { t } = useTranslation('auth')
  const rules = validatePassword(password)

  if (!password) return null

  return (
    <ul className="flex flex-col gap-1.5 text-xs">
      {rules.map((rule) => (
        <li key={rule.id} className="flex items-center gap-2">
          {rule.met ? (
            <Check className="size-3.5 text-primary" />
          ) : (
            <Circle className="size-3.5 text-muted-foreground/40" />
          )}
          <span className={rule.met ? 'text-foreground' : 'text-muted-foreground'}>
            {t(`passwordRules.${rule.id}`)}
          </span>
        </li>
      ))}
    </ul>
  )
}
